import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { createQuizApi } from "../../../services/QuizService";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RichTextEditorComponent from '../../constant/RichTextEditor';

const AddQuiz = () => {
    const navigate = useNavigate();
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [richTextAreaValue, setRichTextAreaValue] = useState("Enter Question");
    const [errors, setErrors] = useState({});
    const [quizData, setQuizData] = useState({
        title: '',
        description: '',
        publish_date: '',
        quiz_start_time: '',
        quiz_end_time: '',
        question: '',
        option_1: '',
        option_2: '',
        option_3: '',
        option_4: '',
        question_number: '',
        correct_option: '',

    });
    const [previewQuestions, setPreviewQuestions] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setQuizData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };


    const handleEditorChange = (newValue) => {
        setQuizData((prevDataInput) => ({
            ...prevDataInput,
            question: newValue,
        }));
        if (richTextAreaValue) {
            setRichTextAreaValue("")
        }
    };

    const validateForm = () => {
        const formErrors = {};
        if (!quizData.title.trim()) {
            formErrors.title = "Quiz Title is required.";
        }

        if (!quizData.description.trim()) {
            formErrors.description = "Quiz Description is required.";
        }

        if (!quizData.publish_date) {
            formErrors.publish_date = "Publish Date is required.";
        } else {
            const enteredDate = new Date(quizData.publish_date);
            //enteredDate.setHours(0, 0, 0, 0);
            // Get today's date without time
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (enteredDate <= today) {
                formErrors.publish_date = "Publish Date must be greather than equals to today date";
            }
        }

        if (!quizData.quiz_start_time) {
            formErrors.quiz_start_time = "Quiz start time is required.";
        } else {
            const startTime = new Date(`${quizData.publish_date}T${quizData.quiz_start_time}`);
            const minStartTime = new Date();
            minStartTime.setMinutes(minStartTime.getMinutes() + 5);

            if (startTime < minStartTime) {
                formErrors.quiz_start_time = "Quiz start time must be at least 5 minutes from now.";
            }

            if (!quizData.quiz_end_time) {
                formErrors.quiz_end_time = "Quiz end time is required.";
            } else {
                const endTime = new Date(`${quizData.publish_date}T${quizData.quiz_end_time}`);

                // Ensure end time is greater than start time
                if (endTime <= startTime) {
                    formErrors.quiz_end_time = "Quiz end time must be after the start time.";
                }
                // Ensure time difference between start and end time is between 15 mins and 1 hour
                const timeDiffMinutes = (endTime - startTime) / 60000; // Time difference in minutes
                if (timeDiffMinutes < 15 || timeDiffMinutes > 60) {
                    formErrors.quiz_end_time = "Quiz duration must be between 15 minutes and 1 hour.";
                }
            }
        }

        if (quizData.question.trim() && quizData.question.trim() !== "Enter Question") {

            if (!quizData.option_1.trim()) {
                formErrors.option_1 = "Option 1 is required.";
            }
            if (!quizData.option_2.trim()) {
                formErrors.option_2 = "Option 2 is required.";
            }
            if (!quizData.option_3.trim()) {
                formErrors.option_3 = "Option 3 is required.";
            }
            if (!quizData.option_4.trim()) {
                formErrors.option_4 = "Option 4 is required.";
            }
            const allOptions = [
                quizData.option_1.trim(),
                quizData.option_2.trim(),
                quizData.option_3.trim(),
                quizData.option_4.trim(),
            ];
            const uniqueOptions = new Set(allOptions.filter((opt) => opt !== ""));
            if (uniqueOptions.size !== allOptions.filter((opt) => opt !== "").length) {
                formErrors.options = "Options must be unique.";
            }
            if (!quizData.correct_option) {
                formErrors.correct_option = "Please select the correct option.";
            }
        } else if (previewQuestions.length === 0) {
            formErrors.question = "Enter Question";
        }
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };



    const validateQuestionForm = () => {
        const formErrors = {};

        if (quizData.question.trim() === "Enter Question") {
            formErrors.question = "Enter Question";
        }

        if (!quizData.option_1.trim()) {
            formErrors.option_1 = "Option 1 is required.";
        }
        if (!quizData.option_2.trim()) {
            formErrors.option_2 = "Option 2 is required.";
        }
        if (!quizData.option_3.trim()) {
            formErrors.option_3 = "Option 3 is required.";
        }
        if (!quizData.option_4.trim()) {
            formErrors.option_4 = "Option 4 is required.";
        }
        const allOptions = [
            quizData.option_1.trim(),
            quizData.option_2.trim(),
            quizData.option_3.trim(),
            quizData.option_4.trim(),
        ];
        const uniqueOptions = new Set(allOptions.filter((opt) => opt !== ""));
        if (uniqueOptions.size !== allOptions.filter((opt) => opt !== "").length) {
            formErrors.options = "Options must be unique.";
        }
        if (!quizData.correct_option) {
            formErrors.correct_option = "Please select the correct option.";
        }

        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setIsSubmitLoading(true);

            try {
                let currentQuestion = null;
                if (quizData.question.trim() && quizData.question.trim() !== "Enter Question") {
                    currentQuestion = {
                        question_number: previewQuestions.length + 1,
                        question: quizData.question,
                        option_1: quizData.option_1,
                        option_2: quizData.option_2,
                        option_3: quizData.option_3,
                        option_4: quizData.option_4,
                        correct_option: quizData.correct_option,

                    };
                }
                const dataToSend = currentQuestion
                    ? [...previewQuestions, currentQuestion]
                    : [...previewQuestions];

                const formData = {
                    title: quizData.title,
                    description: quizData.description,
                    questions: dataToSend,
                    publish_date: quizData.publish_date,
                    quiz_start_time: quizData.quiz_start_time,
                    quiz_end_time: quizData.quiz_end_time
                };
                const response = await createQuizApi(formData);
                toast.success(response.data.message);
                setPreviewQuestions([]);
                setErrors({});
                navigate("/quiz");
            } catch (error) {
                toast.error(error.response?.data?.message || "Something went wrong!");
            } finally {
                setIsSubmitLoading(false);
            }
        }
    };

    const handleAddMoreQuestions = () => {
        if (validateQuestionForm()) {
            if (quizData.question.trim().length === 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    question: "Question cannot be empty.",
                }));
                return;
            }
            else {
                if (!quizData.option_1.trim()) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        option_1: "Option 1 is required.",
                    }));
                }
                if (!quizData.option_2.trim()) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        option_2: "Option 2 is required.",
                    }));
                }
                if (!quizData.option_3.trim()) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        option_3: "Option 3 is required.",
                    }));
                }
                if (!quizData.option_4.trim()) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        option_4: "Option 4 is required.",
                    }));
                }
            }

            const newQuestion = {
                question_number: previewQuestions.length + 1,
                question: quizData.question,
                option_1: quizData.option_1.trim(),
                option_2: quizData.option_2.trim(),
                option_3: quizData.option_3.trim(),
                option_4: quizData.option_4.trim(),
                correct_option: quizData.correct_option,
            };

            setPreviewQuestions([...previewQuestions, newQuestion]);

            // Reset form fields
            setQuizData({
                ...quizData,
                question: '',
                option_1: '',
                option_2: '',
                option_3: '',
                option_4: '',
                correct_option: '',

            });

            // Clear errors
            setErrors({});
            setRichTextAreaValue("Enter Question")

        }
    };

    const handleSaveEdit = () => {
        if (validateForm()) {
            if (quizData.question.trim().length === 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    question: "Question cannot be empty.",
                }));
                return;
            }

            const updatedQuestions = [...previewQuestions];
            updatedQuestions[editingIndex] = {
                question_number: editingIndex + 1,
                question: quizData.question.endsWith('?') ? quizData.question : `${quizData.question}?`,
                option_1: quizData.option_1,
                option_2: quizData.option_2,
                option_3: quizData.option_3,
                option_4: quizData.option_4,
                correct_option: quizData.correct_option,

            };

            setPreviewQuestions(updatedQuestions);

            setQuizData({
                ...quizData,
                question: '',
                option_1: '',
                option_2: '',
                option_3: '',
                option_4: '',
                correct_option: '',

            });
            setErrors({});
            setEditingIndex(null);
        }
    };

    const handleEditQuestion = (index) => {
        const selectedQuestion = previewQuestions[index];
        setQuizData({
            title: quizData.title,
            description: quizData.description,
            question: selectedQuestion.question,
            option_1: selectedQuestion.option_1,
            option_2: selectedQuestion.option_2,
            option_3: selectedQuestion.option_3,
            option_4: selectedQuestion.option_4,
            correct_option: selectedQuestion.correct_option,

        });
        setEditingIndex(index);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center me-5">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm btn-circle"
                                        onClick={() => navigate("/quiz")}
                                    >
                                        <i className="fa-solid fa-arrow-left"></i>
                                    </button>

                                    <h3 className="text-center mb-0 ms-3">Add New Quiz</h3>
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            <div className="row mb-2">
                                {/* Title and Description */}
                                <div className="col-md-6">
                                    <label className="form-label">Quiz Title<span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="title"
                                        value={quizData.title}
                                        onChange={handleInputChange}
                                        placeholder="Enter Quiz Title"
                                    />
                                    {errors.title && <div className="text-danger">{errors.title}</div>}
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Quiz Description<span className="text-danger">*</span></label>
                                    <textarea
                                        className="form-control"
                                        name="description"
                                        value={quizData.description}
                                        onChange={handleInputChange}
                                        placeholder="Enter Quiz Description"
                                    ></textarea>
                                    {errors.description && <div className="text-danger">{errors.description}</div>}
                                </div>


                                {/* Question Field */}
                                <div className="col-md-7 mb-2">
                                    <label className="form-label">Question<span className="text-danger">*</span></label>

                                    <div >
                                        <RichTextEditorComponent
                                            handleChange={handleEditorChange}
                                            initialValue={richTextAreaValue}
                                            style={{ minWidth: "100%" }}
                                        />
                                    </div>
                                    {errors.question && <div className="text-danger">{errors.question}</div>}
                                </div>


                                <div className="col-md-5 mb-2 mt-3  ">
                                    {/* Options */}

                                    {['option_1', 'option_2', 'option_3', 'option_4'].map((option, index) => (
                                        <div key={index} className=" mb-3">
                                            <label className="form-label">{`Option ${index + 1}`}<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name={option}
                                                value={quizData[option]}
                                                onChange={handleInputChange}
                                                placeholder={`Enter Option ${index + 1}`}
                                            />
                                            {errors[option] && <div className="text-danger">{errors[option]}</div>}
                                        </div>
                                    ))}

                                    {errors.options && <div className="text-danger text-center">{errors.options}</div>}

                                    <div className="mb-1">
                                        <label className="form-label">Correct Option<span className="text-danger">*</span></label>
                                        <select
                                            className="form-control"
                                            name="correct_option"
                                            value={quizData.correct_option}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Select Correct Option</option>
                                            <option value="option_1">Option 1</option>
                                            <option value="option_2">Option 2</option>
                                            <option value="option_3">Option 3</option>
                                            <option value="option_4">Option 4</option>
                                        </select>
                                        {errors.correct_option && <div className="text-danger">{errors.correct_option}</div>}
                                    </div>
                                </div>


                                {/* Buttons */}
                                <div className="col-12 d-flex justify-content-center mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary me-2"
                                        onClick={editingIndex !== null ? handleSaveEdit : handleAddMoreQuestions}
                                    >
                                        {editingIndex !== null ? "Save Edit" : "Add More Questions"}
                                    </button>
                                </div>

                            </div>

                            {/* Preview Table */}
                            {previewQuestions.length > 0 && (
                                <div className="mt-4">
                                    <h4>Preview Questions</h4>
                                    <div className="table-responsive">
                                        <table className="table table-bordered " style={{ tableLayout: 'fixed' }}>
                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{ width: "5%" }}>Q No.</th>
                                                    <th style={{ width: "55%" }}>Question</th>
                                                    <th style={{ width: "30%" }}>Options</th>
                                                    <th style={{ width: "10%" }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {previewQuestions.map((question, index) => (
                                                    <tr key={index} className='text-black'>
                                                        <td>{question.question_number}.</td>
                                                        {/* <td style={{ wordWrap: 'break-word' }}>{question.question}</td> */}
                                                        <td className='text-wrap'>
                                                            <div dangerouslySetInnerHTML={{ __html: question.question }}></div>
                                                        </td>

                                                        <td>
                                                            <ul className="list-unstyled mb-0">
                                                                {[question.option_1, question.option_2, question.option_3, question.option_4].map((option, idx) => (
                                                                    <li key={idx} className={`text-wrap mb-1 ${question.correct_option === `option_${idx+1}` ? "text-success": ""}`}>
                                                                        {`${String.fromCharCode(65 + idx)}. ${option}`}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                <button
                                                                    className="btn btn-outline-primary btn-sm ms-1 mx-2"
                                                                    onClick={() => handleEditQuestion(index)}
                                                                >
                                                                    <i className="fa-solid fa-pen-to-square"></i> Edit
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        setPreviewQuestions((prevState) =>
                                                                            prevState.filter((_, idx) => idx !== index)
                                                                        )
                                                                    }
                                                                >
                                                                    <i className="fa-solid fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}



                            {/* Buttons */}
                            <div className='row mt-3'>
                                <div className='col-md-6'>
                                    <label className='form-lable'>Publish Date</label>
                                    <input type="date" className='form-control'
                                        value={quizData.publish_date}
                                        name='publish_date'
                                        onChange={handleInputChange}
                                    />
                                    {errors.publish_date && <div className="text-danger">{errors.publish_date}</div>}
                                </div>

                                <div className="col-md-6 d-flex justify-content-center align-items-center justify-content-between">
                                    <div className='form-group me-sm-3 flex-fill'>
                                        <label className='form-lable'>Quiz Start Time</label>
                                        <input type="time" className='form-control'
                                            value={quizData.quiz_start_time}
                                            name='quiz_start_time'
                                            onChange={handleInputChange}
                                        />
                                        {errors.quiz_start_time && <div className="text-danger">{errors.quiz_start_time}</div>}
                                    </div>
                                    <div className='form-group flex-fill'>
                                        <label className='form-lable'>Quiz End Time</label>
                                        <input type="time" className='form-control'
                                            value={quizData.quiz_end_time}
                                            name='quiz_end_time'
                                            onChange={handleInputChange}
                                        />
                                        {errors.quiz_end_time && <div className="text-danger">{errors.quiz_end_time}</div>}
                                    </div>
                                </div>

                                <div className="col-12 mt-4 d-flex justify-content-center align-items-center">
                                    {editingIndex === null && (
                                        <div>
                                            <button
                                                type="submit"
                                                className="btn btn-primary me-3"
                                                disabled={isSubmitLoading}
                                                onClick={handleSubmit}
                                            >
                                                {isSubmitLoading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    )}
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => navigate("/quiz")}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddQuiz;
